import { render, staticRenderFns } from "./excise.vue?vue&type=template&id=02f50886&scoped=true&"
import script from "./excise.vue?vue&type=script&lang=js&"
export * from "./excise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f50886",
  null
  
)

export default component.exports